import { months } from '../../../data/data';
import { echartSetOption, tooltipFormatter } from './echarts-utils';

/* -------------------------------------------------------------------------- */
/*                     Echart Bar Member info                                 */
/* -------------------------------------------------------------------------- */
const { echarts } = window;

const returningCustomerChartInit = () => {
  const { getColor, getData } = window.phoenix.utils;

  const $returningCustomerChart = document.querySelector(
    '.echart-returning-customer'
  );

  if ($returningCustomerChart) {
    const userOptions = getData($returningCustomerChart, 'echarts');
    const chart = echarts.init($returningCustomerChart);
    const getDefaultOptions = () => ({
      color: getColor('background-color-subtle'),
      legend: {
        data: [
          {
            name: 'Fourth time',
            icon: 'roundRect',
            itemStyle: {
              color: getColor('color-primary-light'),
              borderWidth: 0
            }
          },
          {
            name: 'Third time',
            icon: 'roundRect',
            itemStyle: { color: getColor('color-info-lighter'), borderWidth: 0 }
          },
          {
            name: 'Second time',
            icon: 'roundRect',
            itemStyle: { color: getColor('color-primary'), borderWidth: 0 }
          }
        ],

        right: 'right',
        width: '100%',
        itemWidth: 16,
        itemHeight: 8,
        itemGap: 20,
        top: 3,
        inactiveColor: getColor('text-color-soft'),
        inactiveBorderWidth: 0,
        textStyle: {
          color: getColor('text-color-default'),
          fontWeight: 600,
          fontFamily: 'Nunito Sans'
        }
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'none'
        },
        padding: [7, 10],
        backgroundColor: getColor('background-color-subtle'),
        borderColor: getColor('border-color-base'),
        textStyle: { color: getColor('text-color-emphasis') },
        borderWidth: 1,
        transitionDuration: 0,
        formatter: tooltipFormatter,
        extraCssText: 'z-index: 1000'
      },
      xAxis: {
        type: 'category',
        data: months,
        show: true,
        boundaryGap: false,
        axisLine: {
          show: true,
          lineStyle: { color: getColor('background-color-highlight') }
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          // interval: 1,
          showMinLabel: false,
          showMaxLabel: false,
          color: getColor('text-color-muted'),
          formatter: value => value.slice(0, 3),
          fontFamily: 'Nunito Sans',
          fontWeight: 600,
          fontSize: 12.8
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: getColor('background-color-muted'),
            type: 'dashed'
          }
        }
      },
      yAxis: {
        type: 'value',
        boundaryGap: false,
        axisLabel: {
          showMinLabel: true,
          showMaxLabel: true,
          color: getColor('text-color-muted'),
          formatter: value => `${value}%`,
          fontFamily: 'Nunito Sans',
          fontWeight: 600,
          fontSize: 12.8
        },
        splitLine: {
          show: true,
          lineStyle: { color: getColor('background-color-muted') }
        }
      },
      series: [
        {
          name: 'Fourth time',
          type: 'line',
          data: [62, 90, 90, 90, 78, 84, 17, 17, 17, 17, 82, 95],
          showSymbol: false,
          symbol: 'circle',
          symbolSize: 10,
          emphasis: {
            lineStyle: {
              width: 1
            }
          },
          lineStyle: {
            type: 'dashed',
            width: 1,
            color: getColor('color-primary-light')
          },
          itemStyle: {
            borderColor: getColor('color-primary-light'),
            borderWidth: 3
          },
          zlevel: 3
        },
        {
          name: 'Third time',
          type: 'line',
          data: [50, 50, 30, 62, 18, 70, 70, 22, 70, 70, 70, 70],
          showSymbol: false,
          symbol: 'circle',
          symbolSize: 10,
          emphasis: {
            lineStyle: {
              width: 1
            }
          },
          lineStyle: {
            width: 1,
            color: getColor('color-info-lighter')
          },
          itemStyle: {
            borderColor: getColor('color-info-lighter'),
            borderWidth: 3
          },
          zlevel: 2
        },
        {
          name: 'Second time',
          type: 'line',
          data: [40, 78, 60, 78, 60, 20, 60, 40, 60, 40, 20, 78],
          showSymbol: false,
          symbol: 'circle',
          symbolSize: 10,
          emphasis: {
            lineStyle: {
              width: 3
            }
          },
          lineStyle: {
            width: 3,
            color: getColor('color-primary')
          },
          itemStyle: {
            borderColor: getColor('color-primary'),
            borderWidth: 3
          },
          zlevel: 1
        }
      ],
      grid: { left: 0, right: 8, top: '14%', bottom: 0, containLabel: true }
    });
    echartSetOption(chart, userOptions, getDefaultOptions);
  }
};

export default returningCustomerChartInit;
